const state = {
  data: []
}

const mutations = {
  add (state, { message, type, duration = 5000 }) {
    state.data.push({ message, type, duration })
    const index = state.data.length - 1
    setTimeout(() => {
      state.data.splice(index, 1)
    }, duration)
  }
}

export default {
  state,
  mutations,
  namespaced: true
}
